/**
 * Guides the user through attaching one note to an activity of many deliverables:
 * pick activity of the template -> compose note -> bulk create.
 */
export default function bulkNoteCreationService(
    $q,
    $sbDialog,
    $sbIssueEditorService,
    $sbTeam,
    $sbIssue,
    $sbCurrentProject
) {
    "ngInject";

    return {
        createNoteForDeliverables: createNoteForDeliverables,
    };

    /**
     * Rejects with undefined if the user cancels one of the dialogs.
     *
     * @param {Event} $event
     * @param {Object} options
     * @param {string} options.templateId - the process template shared by all deliverables
     * @param {string[]|string} options.deliverableSet - deliverable IDs or an OData filter condition
     * @returns {Promise}
     */
    function createNoteForDeliverables($event, { templateId, deliverableSet }) {
        let selectedActivity;

        return $q
            .all({
                selectedActivity: $sbDialog.openBulkCreateNoteDialog(
                    $event,
                    templateId
                ),
                teams: $sbTeam.getTeams($sbCurrentProject.pick("id")),
            })
            .then(function (values) {
                selectedActivity = values.selectedActivity;

                return $sbIssueEditorService.showForActivity(
                    selectedActivity.assignedTeam,
                    values.teams
                );
            })
            .then(function (issue) {
                return $sbIssue.createNoteAndAssignTo(issue.note, {
                    deliverableSet,
                    activityTemplateIds: [selectedActivity.id],
                });
            });
    }
}
